(function () {
  var typeSelect   = document.getElementById('ContactForm-type');
  var fieldOrder   = document.getElementById('cf-field-order');
  var fieldProduct = document.getElementById('cf-field-product');
  if (!typeSelect) return;

  function update() {
    var val = typeSelect.value;

    var showOrder   = val === '返品・交換について' || val === '注文内容の変更について';
    var showProduct = val === '商品について';

    /* 表示切り替え */
    if (fieldOrder) {
      fieldOrder.hidden = !showOrder;
      var input = fieldOrder.querySelector('input');
      if (input) input.disabled = !showOrder;
    }
    if (fieldProduct) {
      fieldProduct.hidden = !showProduct;
      var input2 = fieldProduct.querySelector('input');
      if (input2) input2.disabled = !showProduct;
    }
  }

  typeSelect.addEventListener('change', update);
  update(); /* 初期化 */

  /* 送信前バリデーション */
  var form = document.getElementById('ContactForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      var type = typeSelect.value;
      if (!type) {
        e.preventDefault();
        typeSelect.focus();
        typeSelect.style.borderColor = '#c85050';
        typeSelect.style.boxShadow   = '0 0 0 3px rgba(200,80,80,.15)';
        return;
      }
      typeSelect.style.borderColor = '';
      typeSelect.style.boxShadow   = '';
    });
  }
})();
